const brazilianBanks = [
    { code: "001", name: "Banco do Brasil" },
    { code: "033", name: "Santander" },
    { code: "104", name: "Caixa Econômica Federal" },
    { code: "237", name: "Bradesco" },
    { code: "341", name: "Itaú" },
    { code: "260", name: "Nubank" },
    { code: "077", name: "Banco Inter" },
    { code: "212", name: "Banco Original" },
    { code: "290", name: "PagBank (PagSeguro)" },
    { code: "323", name: "Mercado Pago" },
    { code: "336", name: "C6 Bank" },
    { code: "380", name: "PicPay Bank" },
    { code: "197", name: "Stone" },
    { code: "085", name: "Ailos" },
    { code: "748", name: "Sicredi" },
    { code: "756", name: "Sicoob" },
    { code: "041", name: "Banrisul" },
    { code: "004", name: "Banco do Nordeste" },
    { code: "021", name: "Banestes" },
    { code: "047", name: "Banese" },
    { code: "070", name: "BRB - Banco de Brasília" },
    { code: "389", name: "Banco Mercantil do Brasil" },
    { code: "422", name: "Banco Safra" },
    { code: "633", name: "Banco Rendimento" },
    { code: "655", name: "Banco Votorantim" },
    { code: "707", name: "Banco Daycoval" },
    { code: "136", name: "Unicred" },
    { code: "208", name: "Banco BTG Pactual" },
    { code: "623", name: "Banco PAN" },
    { code: "318", name: "Banco BMG" },
    { code: "246", name: "Banco ABC Brasil" },
    { code: "612", name: "Banco Guanabara" },
    { code: "604", name: "Banco Industrial do Brasil" },
    { code: "320", name: "Banco CCB Brasil" },
    { code: "643", name: "Banco Pine" },
    { code: "224", name: "Banco Fibra" },
    { code: "184", name: "Banco Itaú BBA" },
    { code: "025", name: "Banco Alfa" },
    { code: "082", name: "Banco Topázio" },
    { code: "099", name: "Uniprime Central (Cooperativa)" },
    { code: "133", name: "Cresol" },
    { code: "121", name: "Banco Agibank" },
    { code: "094", name: "Banco Finaxis" },
    { code: "364", name: "Gerencianet (Efí)" },
    { code: "536", name: "Neon" },
    { code: "403", name: "Cora" },
    { code: "301", name: "BPP / Dock" },
    { code: "611", name: "Banco Paulista" },
    { code: "243", name: "Banco Master" }
];

export default brazilianBanks;